/**
 * Activities API Service
 * Handles all activity-related API calls
 */

import apiClient from './index.js';

export class ActivitiesApi {
  /**
   * Get list of activities
   */
  static async getActivities(token) {
    return apiClient.get('/activities/v1/list', token);
  }

  /**
   * Get activity details
   * @param {string} token - Auth token
   * @param {string} activityId - Activity ID
   */
  static async getActivityDetails(token, activityId) {
    return apiClient.get(`/activities/v1/details/${activityId}`, token);
  }

  /**
   * Add a new activity
   * @param {string} token - Auth token
   * @param {Object} activityData - Activity data
   */
  static async addActivity(token, activityData) {
    return apiClient.post('/activities/v1/add', token, activityData);
  }

  /**
   * Delete activity
   * @param {string} token - Auth token
   * @param {string} activityId - Activity ID
   */
  static async deleteActivity(token, activityId) {
    return apiClient.delete(`/activities/v1/delete/${activityId}`, token);
  }
}

export default ActivitiesApi;
